import { DetailCruiseExtras } from '../cruise/classes/DetailCruiseExtras'
import { DetailFlightPrices } from '../cruise/classes/DetailFlightPrices'

export const useState = (): PriceState => {
  return {
    cheapestFlightPrices: null,
    extras: null
  }
}

export interface PriceState {
  cheapestFlightPrices: DetailFlightPrices | null
  extras: DetailCruiseExtras | null
}
